import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DefaultModal from 'GeneralUI/DefaultModal/DefaultModal.jsx'
import { useSelector } from 'react-redux'

const ModalFramework = ({
  startingZIndex = 1000000,
  coverOpacity = 0.5,
  coverEnabled = true
}) => {
  const modals = useSelector(state => state.modal)

  const maxOpacity = useMemo(
    () =>
      (modals || []).reduce((opacity, modal) => {
        if (
          modal.config &&
          modal.config.opacity &&
          parseFloat(modal.config.opacity) > parseFloat(opacity)
        ) {
          return modal.config.opacity
        } else {
          return opacity
        }
      }, coverOpacity),
    [coverOpacity, modals]
  )

  return (
    <div id="modal-framework-default">
      <ModalScreenCover
        coverOpacity={maxOpacity}
        coverVisible={coverEnabled && modals && modals.length > 0}
        zIndex={
          startingZIndex +
          modals.length -
          1 /* length - 1 because length is 1 based not 0 based */
        }
      />
      {modals.map((modal, idx) => (
        <DefaultModal
          modal={modal}
          key={modal.address}
          style={{ zIndex: startingZIndex + idx }}
          config={modal.config}
        />
      ))}
    </div>
  )
}

const ModalScreenCover = ({ coverOpacity, coverVisible, zIndex }) => {
  const handleMouseDownCapture = e => {
    // don't cause what's underneath to lose focus
    e.preventDefault()
    e.stopPropagation()
  }

  if (coverVisible) {
    return (
      <div
        className="modal-screen-cover"
        style={{
          zIndex,
          backgroundColor: `rgba(0,0,0,${coverOpacity})`
        }}
        onMouseDownCapture={handleMouseDownCapture}
      />
    )
  } else {
    return null
  }
}

export default ModalFramework

ModalFramework.propTypes = {
  startingZIndex: PropTypes.number,
  coverOpacity: PropTypes.number,
  coverEnabled: PropTypes.bool
}
